import axios from 'axios'

// Use relative URL when proxy is enabled
const baseURL = process.env.VUE_APP_USE_PROXY === 'true' 
  ? '' 
  : process.env.VUE_APP_BASE_URL_EXTERNAL;

const HTTP_ = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
})

const stripContentTypeForFormData = (req) => {
    if (!req || !req.data || typeof FormData === 'undefined') {
        return req
    }
    if (req.data instanceof FormData) {
        if (req.headers && typeof req.headers.delete === 'function') {
            req.headers.delete('Content-Type')
        } else if (req.headers) {
            delete req.headers['Content-Type']
            delete req.headers['content-type']
        }
    }
    return req
}

HTTP_.interceptors.request.use(
    function (req) {
        return stripContentTypeForFormData(req)
    },
    function (err) {
        return Promise.reject(err)
    }
)
export default HTTP_
